import React from 'react';
import PropTypes from 'prop-types';

const PromotionReviewStatusLabel = ({
  status,
  isFinal,
  isLive,
}) => {
  const labelTextPending = isFinal ? 'Pendiente validación' : 'Pendiente revisión';
  const labelTextClosed = isFinal ? 'Entrega validada' : 'Revisión finalizada';

  return (
    <div
      className={`promotion-review-status-label${(status === 'pending' || (isFinal && !isLive)) ? '' : ' disabled'}`}
    >
      <span>{status === 'pending' ? labelTextPending : labelTextClosed}</span>
    </div>
  );
};

PromotionReviewStatusLabel.propTypes = {
  status: PropTypes.string.isRequired,
  isFinal: PropTypes.bool.isRequired,
  isLive: PropTypes.bool.isRequired,
};

export default PromotionReviewStatusLabel;
